// #region IMPORT
import { m } from 'framer-motion';

import { Box, Grid, Stack, Button, Container, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

import { CONFIG } from 'src/global/config-global';

import { varScale } from 'src/components/animate';
// #endregion
interface Props {
  onOpenRegisterForm?: (value: boolean) => void;
}

export const Intergration = ({ onOpenRegisterForm }: Props) => {
  const mdUp = useResponsive('up', 'md');
  const smUp = useResponsive('up', 'sm');

  return (
    <Stack py={{ xs: 0, sm: 3, md: 10 }} height={1}>
      <Container sx={{ position: 'relative', zIndex: 3 }}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={7} lg={7}>
            <Stack height={1} alignItems={mdUp ? 'unset' : 'center'}>
              <Typography
                fontFamily='"Shantell Sans Light", sans-serif'
                color="primary.main"
                fontWeight="bold"
              >
                CenterUp Brain
              </Typography>
              <Typography
                variant="h2"
                fontWeight="bold"
                mt={2}
                mb={2.5}
                textAlign={mdUp ? 'unset' : 'center'}
              >
                Trợ lý AI đa nhiệm
              </Typography>
              <Typography
                variant="body1"
                textAlign={mdUp ? 'unset' : 'center'}
                mb={smUp ? 6 : 3}
                pr={{ lg: 16, md: 10, sm: 0 }}
              >
                Từ vận hành hiệu quả đến giảng dạy chất lượng và chăm sóc học viên sát sao – Center
                Brain là trợ lý AI toàn diện cho trung tâm của bạn.
              </Typography>
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  size={smUp ? 'large' : 'medium'}
                  sx={{ px: 2.8 }}
                  onClick={() => onOpenRegisterForm?.(true)}
                >
                  Đăng ký Demo
                </Button>
              </Box>
            </Stack>
          </Grid>
          <Grid
            item
            xs={12}
            md={5}
            lg={5}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Box
              component={m.img}
              variants={{ ...varScale().in, initial: { scale: 0.8, opacity: 0 } }}
              alt="Integration"
              src={`${CONFIG.assetsDir}/assets/landing/intergration/ai_assist.svg`}
              sx={{ objectFit: 'contain', alignItems: 'center' }}
            />
          </Grid>
        </Grid>
      </Container>
    </Stack>
  );
};
